<script setup>
import { ref, onMounted } from 'vue'
import { useWebSiteStore } from '@/stores/website.store'
import { useNotify } from '@/composables/notify'
import { useRoute, useRouter } from 'vue-router'
import i18n from '@/plugins/i18n'

const route = useRoute()
const router = useRouter()
const token = ref('')
const newPassword = ref('')
const isPwd = ref(true)

const loading = ref(false)

const websiteStore = useWebSiteStore()
const t = i18n.global.t
const { notifyError } = useNotify()

const resetPasswordAsync = async() => {
  try {
    loading.value = true
    if (!token.value) {
      notifyError(t('auth.errors.missingResetToken'))
      return
    }
    await websiteStore.resetPasswordAsync(token.value, newPassword.value)
  } catch (error) {
    notifyError(t('error.passwordRules'))
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  token.value = route.query.token || null
  router.replace({ query: {} })
})

</script>

<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <q-page class="flex flex-center bg-gradient">
        <div class="column items-center q-gutter-md">
          <div class="text-h5">
            {{ $t('auth.resetPassword') }}
          </div>

          <div class="q-mt-lg column login-card">
            <q-input
              v-model="newPassword"
              outlined
              class="q-mt-md"
              :type="isPwd ? 'password' : 'text'"
              :placeholder="$t('auth.password')"
            >
              <template #prepend>
                <q-icon name="mdi-lock" />
              </template>
              <template #append>
                <q-icon
                  :name="isPwd ? 'mdi-eye-off' : 'mdi-eye'"
                  class="cursor-pointer"
                  @click="isPwd = !isPwd"
                />
              </template>
            </q-input>

            <div class="q-mt-lg">
              <q-btn
                color="primary"
                class="full-width q-pa-sm"
                :label="$t('auth.resetPassword')"
                :loading="loading"
                @click="resetPasswordAsync"
              />
            </div>

            <div class="login-actions column items-center q-mt-md">
              <div class="no-account row items-center">
                <span class="text-white">{{ $t('auth.rememberedPassword') }}</span>
                <router-link
                  to="/login"
                  class="signup-link q-ml-sm"
                >
                  {{ $t('auth.signIn') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<style lang="scss" scoped>
@import '@/styles/auth-forms.scss';
</style>
